import { translate, translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import styled from '@emotion/styled';
import {
  spacing,
  mediaMax,
  fontSize,
  fontWeight,
} from 'presentations/views/styles';
import ServicePageTemplate from 'presentations/views/components/templates/ServicePageTemplate';
import CustomerStoryList from 'presentations/views/components/organisms/CustomerStoryList';
import { useCustomerStoryListPage } from './hooks';
import Breadcrumbs from 'presentations/views/components/organisms/Breadcrumbs';
import { ReactNode, useMemo } from 'react';
import { CustomerStoryListItem } from 'presentations/api/schema/contents';
import { Props as PaginationProps } from 'presentations/views/components/atoms/Pagination';
import TopTitle from '../ResourceListPage/TopTitle';

export interface Props {
  title: string;
  customers: CustomerStoryListItem[];
  paginationProps: PaginationProps;
  breadcrumbs: { title: string; link: string }[];
  siderbar?: ReactNode;
  header?: ReactNode;
}

export default function Component(props: Props) {
  const { state, actions } = useCustomerStoryListPage({
    breadcrumbs: props.breadcrumbs,
  });
  const t = useMemo(() => translateInComponent(translations), [translations]);
  return (
    <ServicePageTemplate
      breadcrumbs={<Breadcrumbs routes={state.routes} />}
      header={props.header}
    >
      <Container>
        <TopTitle title={props.title} description={t('description')} />
        <CustomerStoryList
          title={props.title}
          items={props.customers}
          paginationProps={props.paginationProps}
        />
        {props.siderbar && (
          <SidebarContainer>{props.siderbar}</SidebarContainer>
        )}
      </Container>
    </ServicePageTemplate>
  );
}

const Container = styled.div`
  max-width: 1080px;
  margin: ${spacing(64)} auto ${spacing(80)};

  ${mediaMax.desktop} {
    margin: 0 ${spacing(24)};
  }
  ${mediaMax.tablet} {
    flex-direction: column;
    margin: ${spacing(24)} 0;
  }
  ${mediaMax.xs} {
    width: 100%;
  }
`;

const SidebarContainer = styled.div`
  width: 274px;
  min-width: 274px;

  ${mediaMax.tablet} {
    margin: ${spacing(32)} 0 0 0;
    width: inherit;
    min-width: inherit;
  }
`;

const CategoryNameContainer = styled.div`
  display: flex;
  align-items: center;
  margin: ${spacing(40)} auto;
  ${mediaMax.desktop} {
    margin: ${spacing(24)} auto;
  }
`;
const CategoryTitle = styled.div`
  font-size: ${fontSize(32)};
  font-weight: ${fontWeight('bold')};
  ${mediaMax.tablet} {
    font-size: ${fontSize(24)};
  }
`;
